import {closePopup} from '../actions';
import * as ActionTypes from '../actions/actionTypes';
import {updateTimeOrchestrator} from '../orchestrators';
import {flooredHour} from '../utils/time_utils';

const _calcNextTime = (state, current_time) => {
  const { indicators, time } = state;
  if (indicators.active) {
    const available_times = indicators.active.available_times;
    const current_time_index = available_times.points.indexOf(current_time);

    if (current_time_index >= available_times.points.length - 1) {
      // At the end of the times, loop back to now.
      const available_time_index = available_times.contained_points[flooredHour(new Date())];
      return available_time_index ? available_times.intervals[available_time_index].point_at : null;
    }
    if (current_time_index !== -1) {
      return available_times.points[current_time_index + 1];
    }
  } else {
    const available_times = time.valid_times;
    const current_time_index = available_times.indexOf(current_time);

    if (current_time_index >= available_times.length - 1) {
      // At the end of the times, loop back to now.
      const time_index = available_times[flooredHour(new Date())];
      return time_index ? available_times[time_index] : null;
    }
    if (current_time_index !== -1) {
      return available_times[current_time_index + 1];
    }
  }
  return null;
};

const _setTimer = (state, dispatch, next_time) => {
  if (next_time) {
    // 1 = 1s, 2 = 0.5s, 3 = 0.33s
    const delay = 1000 / state.play.speed;
    let timer = setTimeout(() => dispatch({ type: ActionTypes.TICK_PLAYING, time: next_time }), delay);
    dispatch({ type: ActionTypes.SET_TIMER, timer, next_time });
  }
};

export const orchestratePlay = store => next => action => {

  const state = store.getState();
  const dispatch = store.dispatch;

  switch (action.type) {

    case ActionTypes.START_PLAYING:
      dispatch(closePopup());
      clearInterval(state.play.timer);
      _setTimer(state,
        dispatch,
        _calcNextTime(state, state.time.display_time ? state.time.display_time : state.time.selected_time));
      break;

    case ActionTypes.TICK_PLAYING:
      clearInterval(state.play.timer);
      if (state.play.playing) {
        dispatch(updateTimeOrchestrator(action.time));
        _setTimer(state, dispatch, _calcNextTime(state, action.time));
      }
      break;

    case ActionTypes.STOP_PLAYING:
      clearInterval(state.play.timer);
      break;

    default:
      break;
  }

  return next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/playMiddleware.js